module.exports = __webpack_public_path__ + "img/delimage.ab3393bb.jpg";